//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import { ReactComponent as Down } from "../../../../Media/Icon/010.svg";

//Element
class Submenu extends Component {
    //Element
    onClick = (e) => {
        //Element
        e.preventDefault()
        //Element
        console.log(e)
        //Element
        e.target.nextElementSibling.classList.toggle("d-block")
        //Element
        e.nativeEvent.target.classList.toggle("border-0")

    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB j11251 d-none" },
            //Element
            React.createElement(Container, {},
                //Element
                React.createElement(Row, {},
                    //Element
                    React.createElement(Col, { md: 12 },
                        //Element
                        React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB c008vi" },
                            //Element
                            React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB x3914c" },
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az" },
                                        //Element
                                        "Əsas"
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/", onClick: this.onClick },
                                        //Element
                                        "Korporativ",
                                        //Element
                                        React.createElement(Down, {})
                                    ),
                                    //Element
                                    React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/haqqimizda" },
                                                //Element
                                                "Haqqımızda"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/tarixce" },
                                                //Element
                                                "Tarixçə"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/filiallar" },
                                                //Element
                                                "Filiallar"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/səlahiyyət-sənədləri" },
                                                //Element
                                                "Səlahiyyət Sənədləri"
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/", onClick: this.onClick },
                                        //Element
                                        "Təqdim Edilən Xidmətlər",
                                        //Element
                                        React.createElement(Down, {})
                                    ),
                                    //Element
                                    React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB" },
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/isiqlandirma" },
                                                //Element
                                                "İşıqlandırma"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/panel-istehsali" },
                                                //Element
                                                "Panel İstehsalı"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/elektrik-muqavilesi" },
                                                //Element
                                                "Elektrik Müqaviləsi"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/yenilene-bilen-enerji" },
                                                //Element
                                                "Yenilənə Bilən Enerji"
                                            )
                                        ),
                                        //Element
                                        React.createElement("li", { className: "S6pt64 C96Q4r" },
                                            //Element
                                            React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/orta-gerginlik-tesisleri" },
                                                //Element
                                                "Orta Gərginlik Təsisləri"
                                            )
                                        )
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/layiheler" },
                                        //Element
                                        "Layihələr"
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/davamliliq" },
                                        //Element
                                        "Davamlılıq"
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/karyera" },
                                        //Element
                                        "Karyera"
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/az/elaqe" },
                                        //Element
                                        "Əlaqə"
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Submenu;